{
    "MainmenuPinmenu": "Menu Pin",
    "MainmenuPinnedmenu": "Menu Déplacer",
    "MainmenuHome": "Accueil",
    "MainmenuMoreoptions": "Plus d'options",
    "MainmenuWhatisnew": "Quoi de neuf ?",
    "MainmenuOmnichannelPanel": "Panel omnicanal",
    "MainmenuPrivacynotice": "Avis de confidentialité",
    "MainMenuCookiePolicy": "Politique en matière de cookies",
    "MainmenuTermsofservice": "Conditions d'utilisation",
    "MainmenuSetlanguage": "Définir la langue",
    "MainmenuHelp": "Aide",
    "MainmenuChangePassword": "Changer le mot de passe",
    "MainmenuServerInfo": "Informations sur le serveur",
    "MainmenuSendfeedback": "Envoyez-nous vos commentaires !",
    "MainmenuButtonTitleAddreport": "Ajouter un nouveau rapport",
    "MainmenuButtonTitleDeletereport": "Supprimer le rapport",
    "MainmenuButtonTitlePermanentlyDeletereport": "Supprimer définitivement le rapport",
    "MainmenuButtonSubTitleDisabled": "(Sélectionnez certains rapports pour utiliser cette option)",
    "NAME": "LanguageMainMenu",
    "MainMenu_RestartTour": "Redémarrer la visite",
    "MAIN_MENU_SETTINGS_CLEAR_CONTENTFUL_CACHE": "Effacer le cache du contenu",
    "MainMenu_Turn_On_Insights_Hub": "Activer le tableau de bord Insights",
    "MainMenu_Turn_Off_Insights_Hub": "Désactiver le tableau de bord Insights",
    "MainMenu_Timezone": "Changer de fuseau horaire"
}